module.exports = function (data) {
    const event = {
        event: 'BWSAUInternalCampaignClick',
        eventContext: {
            eventType: data.type, //Track if the campaign click is a merch card or carousels or banners
            eventCampaignName: data.campaignName || '', //Track the id of the campaign
            eventPlace: data.place, //Track the place of the campaign click
            eventPosition: data.position //Track the position of the merch card/ carousel
        }
    };

    if (data.promoteIQCampaignId || data.linkName || data.linkType) {
        event.eventContext.promoteIQCampaignId = data.promoteIQCampaignId || '';
        event.eventContext.linkName = data.linkName || '';
        event.eventContext.linkType = data.linkType || '';
    }

    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/atm-mapper-internal-campaign.js
 **/